import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

interface ReintentarModalType {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ReintentarModal: React.FC<ReintentarModalType> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation("reintentarModal");
  return (
    <Dialog
      open={open}
      onClose={onClose}
      keepMounted
      aria-labelledby="alert-dialog-retry-title"
      aria-describedby="alert-dialog-retry-description"
      PaperProps={{
        sx: {
          height: "auto",
          width: "382px",
        },
      }}
    >
      <DialogTitle
        sx={{
          color: "#000000",
          fontSize: "24px",
          padding: "28px",
          paddingBottom: "21px",
        }}
      >
        {t("title")}
      </DialogTitle>
      <DialogContent sx={{ paddingX: "28px", paddingBottom: "0px" }}>
        <DialogContentText sx={{ color: "#333333", fontSize: "14px" }}>
          {t("message")}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ padding: "18px", paddingTop: "27px" }}>
        <Button onClick={onClose} color="primary" variant="outlined">
          {t("actions.cancel", { ns: "common" })}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          {t("retryButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReintentarModal;
